import { render, staticRenderFns } from "./UserInfoVue.vue?vue&type=template&id=06e884a2&scoped=true"
import script from "./UserInfoVue.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoVue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserInfoVue.vue?vue&type=style&index=0&id=06e884a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e884a2",
  null
  
)

export default component.exports